'use strict'
function __export(m) {
  for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p]
}
Object.defineProperty(exports, '__esModule', { value: true })
__export(require('./convertTokens'))
var legacyParse_1 = require('./legacyParse')
exports.legacyParse = legacyParse_1.default
var legacyParseMap_1 = require('./legacyParseMap')
exports.legacyParseMap = legacyParseMap_1.default
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@date-fns/upgrade/v2/index.js
// module id = 386
// module chunks = 10